import React from 'react';
import ReactModal from 'react-modal';

type BlockingModalProps = {
  isOpen: boolean;
  children: React.ReactNode;
  style?: ReactModal.Styles;
};

const BlockingModal: React.FC<BlockingModalProps> = ({
  isOpen,
  children,
  style,
}: BlockingModalProps) => {
  const modalStyle: ReactModal.Styles = {
    overlay: { zIndex: 500, minHeight: '100vh' },
    ...style,
  };
  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      contentLabel="Please wait"
      className="checkout-panel-main base-modal central-modal rounded-lg shadow-xl"
      style={modalStyle}
    >
      {children}
    </ReactModal>
  );
};

export default BlockingModal;
